var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87988 19.4001C6.46988 19.4001 6.12988 19.0601 6.12988 18.6501V16.5801C6.12988 16.1701 6.46988 15.8301 6.87988 15.8301C7.28988 15.8301 7.62988 16.1701 7.62988 16.5801V18.6501C7.62988 19.0701 7.28988 19.4001 6.87988 19.4001Z",
    fill: "#3E485B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.4C11.59 19.4 11.25 19.06 11.25 18.65V14.5C11.25 14.09 11.59 13.75 12 13.75C12.41 13.75 12.75 14.09 12.75 14.5V18.65C12.75 19.07 12.41 19.4 12 19.4Z",
    fill: "#3E485B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1201 19.4002C16.7101 19.4002 16.3701 19.0602 16.3701 18.6502V12.4302C16.3701 12.0202 16.7101 11.6802 17.1201 11.6802C17.5301 11.6802 17.8701 12.0202 17.8701 12.4302V18.6502C17.8701 19.0702 17.5401 19.4002 17.1201 19.4002Z",
    fill: "#3E485B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88007 13.6799C6.54007 13.6799 6.24007 13.4499 6.15007 13.1099C6.05007 12.7099 6.29007 12.2999 6.70007 12.1999C10.3801 11.2799 13.6201 9.26992 16.0901 6.39992L16.5501 5.85992C16.8201 5.54992 17.2901 5.50992 17.6101 5.77992C17.9201 6.04992 17.9601 6.51992 17.6901 6.83992L17.2301 7.37992C14.5601 10.4999 11.0401 12.6699 7.06007 13.6599C7.00007 13.6799 6.94007 13.6799 6.88007 13.6799Z",
    fill: "#3E485B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1199 10.0201C16.7099 10.0201 16.3699 9.6801 16.3699 9.2701V7.1001H14.1899C13.7799 7.1001 13.4399 6.7601 13.4399 6.3501C13.4399 5.9401 13.7799 5.6001 14.1899 5.6001H17.1199C17.5299 5.6001 17.8699 5.9401 17.8699 6.3501V9.2801C17.8699 9.6901 17.5399 10.0201 17.1199 10.0201Z",
    fill: "#3E485B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.25H9C3.57 23.25 1.25 20.93 1.25 15.5V9.5C1.25 4.07 3.57 1.75 9 1.75H15C20.43 1.75 22.75 4.07 22.75 9.5V15.5C22.75 20.93 20.43 23.25 15 23.25ZM9 3.25C4.39 3.25 2.75 4.89 2.75 9.5V15.5C2.75 20.11 4.39 21.75 9 21.75H15C19.61 21.75 21.25 20.11 21.25 15.5V9.5C21.25 4.89 19.61 3.25 15 3.25H9Z",
    fill: "#3E485B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.0a20898ae3b2f8398af69ea42d38e897.svg";
export { ForwardRef as ReactComponent };